var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCurrentStreak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 31,
    viewBox: "0 0 23 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8548 30.2524C18.1446 30.2524 23 25.3571 23 17.9876C23 5.84238 12.5842 0.747528 5.44072 0.747528C3.96414 0.747528 2.99306 1.33284 2.99306 2.41034C2.99306 2.83602 3.17929 3.2617 3.49855 3.64747C5.20127 5.69605 6.65124 7.75794 6.67785 10.2455C6.67785 10.4317 6.66455 10.6047 6.63794 10.7909C5.79988 9.06158 4.56275 8.21022 3.41874 8.21022C2.71371 8.21022 2.24812 8.68911 2.24812 9.46066C2.24812 9.92624 2.34124 10.5914 2.34124 11.3097C2.34124 14.4225 0 15.8325 0 20.8343C0 26.4878 4.32331 30.2524 10.8548 30.2524ZM11.1874 25.8094C8.72643 25.8094 7.09023 24.3461 7.09023 22.1379C7.09023 19.8765 8.68652 19.1582 8.88606 17.4688C8.91267 17.2692 9.0856 17.1761 9.27183 17.3357C9.83054 17.8545 10.2163 18.5197 10.509 19.3444C11.1741 18.2403 11.3736 16.4312 11.1209 14.4624C11.0677 14.2362 11.2539 14.1165 11.4534 14.1963C14.2869 15.4601 15.8433 18.2536 15.8433 20.9806C15.8433 23.6544 14.2071 25.8094 11.1874 25.8094Z",
    fill: "#DC6215"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCurrentStreak);
export default ForwardRef;